module.exports = __webpack_public_path__ + "static/labelscape-logo-00a83eb057dd39473d6fbf76ca8562ec.svg";